<template>
  <div>
    <!-- <div class="socialLearning_social-learning-detail" > -->
    <div
      class="socialLearning_social-learning-detail"
      style="
        position: absolute;
        z-index: 9999;
        background: #fff;
        top: 0px;
        width: 100%;
        height: 100%;
      "
      v-if="detail"
    >
      <div class="sm_star">
        <!-- header -->
        <div class="sm_header">
          <h1>{{ $t("S10037") }}</h1>
          <button class="back_btn" @click="goBacKPreviousPage">
            <span>back btn</span>
          </button>
          <div class="more-btn-parent-div">
            <button
              class="more_btn"
              @click="toggleMore"
              v-if="
                !detail.owner ||
                selectedChild.modify === true ||
                selectedChild.remove === true
              "
            >
              <span>more btn</span>
            </button>

            <!-- 수정삭제신고 { name: 'SLEdit', params: { postId: detail.id } } -->
            <div class="more_box" v-if="detail" style="display: none">
              <a
                class="cursor-pointer"
                v-if="!detail.owner"
                @click="askForReport(detail.report)"
                >{{ $t("1446") }}</a
              >
              <a
                class="cursor-pointer"
                @click="
                  $router.push(
                    '/ePromoter/' + detail.id + '/edit?bId=' + boardId
                  )
                "
                v-if="
                  selectedChild && selectedChild.modify === true && detail.owner
                "
                >{{ $t("1448") }}</a
              >
              <a
                class="cursor-pointer"
                v-if="
                  selectedChild && selectedChild.remove === true && detail.owner
                "
                @click="askForDelete"
              >
                {{ $t("1449") }}
              </a>
              <!-- <a
              class="cursor-pointer"
              @click="
              $router.push({ name: 'SLEdit', params: { postId: detail.id } })
            "
              v-if="detail.owner"
            >{{ $t("1448") }}</a>
            <a class="cursor-pointer" v-if="detail.owner" @click="askForDelete">
              {{
              $t("1449")
              }}
            </a> -->
            </div>
          </div>
          <!--// 수정삭제신고 -->
          <!-- {{ detail}} -->
        </div>
        <!-- //header -->

        <!-- content -->
        <div class="sm_wrap" v-if="detail">
          <div class="sm_list view">
            <div class="sm_list_box">
              <!-- list-->
              <div class="list_box">
                <!-- userbox -->
                <div class="user_box">
                  <div class="user_img">
                    <img
                      :src="
                        detail.auditor &&
                        detail.auditor.register &&
                        detail.auditor.register.profile
                          ? detail.auditor.register.profile
                          : '/images/user.png'
                      "
                    />
                  </div>
                  <div class="user_txt">
                    <p class="name">
                      {{
                        detail.auditor.register.name
                          ? detail.auditor.register.name.fullName
                          : $t("S10082")
                      }}
                    </p>
                    <p v-show="detail.auditor.register.storeName" class="date">
                      {{
                        detail.auditor.register.storeName
                      }}
                      |
                      {{
                        detail.auditor.register.responsibilityName
                      }}
                    </p>
                    <p style="font-size: 12px">
                      {{
                        $moment(
                          detail.auditor ? detail.auditor.register.time : ""
                        ).format("YYYY.MM.DD")
                      }}
                    </p>
                  </div>

                  <!-- <div class="user_date">
                  {{
                  $moment(detail.auditor?detail.auditor.register.time:'').format("YYYY.MM.DD")
                  }}
                </div> -->
                </div>
                <!-- //userbox -->

                <div class="user_con">
                  {{ detail.contents.subject }}
                  <br />
                  <span
                    v-html="
                      detail.contents.body.replace(/(\r\n|\n|\r)/gm, '<br/>')
                    "
                  ></span>
                </div>

                <div class="user_tag">
                  <span v-for="(tag, i) in detail.tags" :key="i"
                    >#{{ tag.name }}</span
                  >
                </div>

                <div class="user_imgList view" style="position: relative">
                  <a
                    href="javascript:void(0)"
                    v-for="(img, i) in detail.contents.images"
                    :key="i"
                    @click="fileDisply(img)"
                  >
                    <img :src="img.resourceUri" :alt="img.originalName" />
                  </a>

                  <a
                    href="javascript:void(null)"
                    v-if="
                      detail.contents.video && detail.contents.video.resourceUri
                    "
                    @click="fileDisply(detail.contents.video)"
                  >
                    <video-player
                      class="video-player-box"
                      v-if="
                        detail.contents.video &&
                        detail.contents.video.resourceUri
                      "
                      :options="{
                        muted: true,
                        language: 'en',
                        playbackRates: [0.7, 1.0, 1.5, 2.0],
                        sources: [
                          {
                            type: detail.contents.video.contentType,
                            src: detail.contents.video.resourceUri,
                          },
                        ],
                        width: getWHieght(),
                      }"
                      :playsinline="true"
                    />
                    <div
                      style="
                        position: absolute;
                        background-color: transparent;
                        width: 120px;
                        height: 100px;
                        margin-top: -100px;
                        z-index: 999;
                      "
                    ></div>
                  </a>
                </div>

                <div class="user_opt">
                  {{ $t("1437", { str: detail.likesCount }) }} &nbsp;&nbsp;
                  {{ $t("1438", { str: detail.commentCount }) }}
                  <span class="right">
                    {{ $t("1439", { str: detail.viewCount }) }}
                  </span>
                </div>

                <div class="list_btn">
                  <a
                    @click="patchLikeState(detail.id, detail.like)"
                    class="like"
                    :class="{ on: detail.like }"
                    >{{ $t("1440") }}</a
                  >
                  <a class="reply">{{ $t("1441") }}</a>
                </div>

                <div
                  class="comment_box"
                  style="
                    bottom: 50px;
                    background: transparent;
                    border: 0;
                    display: flex;
                    white-space: nowrap;
                    overflow-x: auto;
                  "
                  v-if="form.images.length > 0"
                >
                  <div
                    class="post-video position-relative mgr-20 mgb-32"
                    v-for="(img, i) in form.images"
                    :key="i"
                    style="width: 100px"
                  >
                    <img
                      :src="img.resourceUri"
                      :alt="img.originalName"
                      style="width: 100px"
                      v-if="getType(img.contentType) == 'image'"
                    />
                    <video-player
                      v-if="getType(img.contentType) == 'video'"
                      class="video-player-box"
                      :options="{
                        muted: true,
                        language: 'en',
                        playbackRates: [0.7, 1.0, 1.5, 2.0],
                        sources: [
                          { type: img.contentType, src: img.resourceUri },
                        ],
                        height: 100,
                        width: 100,
                      }"
                      :playsinline="true"
                    />

                    <span
                      @click="form.images.splice(i, 1)"
                      class="remove-img remove-image-new position-absolute t-color-white"
                      ><img src="/images/close.svg" style="width: 20px;}"
                    /></span>
                  </div>

                  <!-- <div class="post-video position-relative mgr-32 mgb-32" v-if="form.images.length > 0 && getType(form.images[0].contentType) == 'video'" style="width: 120px;" >
                      <video-player
                        class="video-player-box"
                        :options="{muted: true, language: 'en', playbackRates: [0.7, 1.0, 1.5, 2.0], sources: [{type: form.images[0].contentType, src: form.images[0].resourceUri }], height: 100, width:120}"
                        :playsinline="true"
                      />

                      <span @click="resetVideo" class="remove-img remove-image-new position-absolute t-color-white"><img src="/images/close.svg" style="width: 20px;}" /></span>

                    </div> -->
                </div>
              </div>

              <!-- comment -->
              <div
                class="comment_box"
                v-if="selectedChild && selectedChild.register === true"
              >
                <div class="comment_area">
                  <input
                    type="file"
                    id="commentFileUpload"
                    accept="image/jpeg, image/png, video/mp4"
                    @change="uploadFile"
                    class="d-none"
                  />
                  <!--<button type="button" class="picture_btn">사진 업로드</button>-->
                  <button
                    type="button"
                    class="picture_btn"
                    @click="openFileUpload(true)"
                  ></button>
                  <button
                    type="button"
                    :disabled="isButtonDisabled"
                    class="comment_btn"
                    :class="{ on: coomentActiveButton }"
                    @click="submitComment"
                  >
                    댓글 업로드
                  </button>
                  <!-- <label style="color:red" v-if="commentValid" >Comment text required</label> -->
                  <textarea
                    @keyup="resizeIt($event.target.value)"
                    @click="setActive"
                    class="comment_textarea"
                    :class="{ commentInvaliderror: commentValid }"
                    v-model="form.contents"
                    :placeholder="$t('1445')"
                    id="comment_textarea"
                    style="padding: 0px 0 16px 0; line-height: 1.5"
                  ></textarea>
                  <!-- style="padding: 16px; line-height: 1.5;" -->
                </div>
              </div>
            </div>
            <!-- //list-->

            <div
              class="sm_list_box"
              style="margin-top: 5px"
              v-if="comments && comments.length > 0"
            >
              <!-- list-->
              <div class="list_box" style="background: #f9f9f9">
                <!-- reply -->
                <div
                  class="reply_wrap"
                  v-for="comment in comments"
                  :key="comment.id"
                >
                  <div class="reply_box">
                    <!-- userbox -->
                    <div class="user_box">
                      <div class="user_img">
                        <img
                          v-if="comment.auditor.register.profile"
                          :src="comment.auditor.register.profile"
                          :alt="comment.auditor.register.name && comment.auditor.register.name.fullName"
                        />
                        <img
                          v-else
                          src="/images/avatar_image.png"
                          :alt="comment.auditor.register.name && comment.auditor.register.name.fullName"
                        />
                      </div>
                      <div class="user_txt">
                        <p class="name">
                          {{ comment.auditor.register.name ? comment.auditor.register.name.fullName : $t("S10082") }}
                        </p>
                        <p v-show="comment.auditor.register.storeName" class="date">
                          {{ comment.auditor.register.storeName }} |
                          {{ comment.auditor.register.responsibilityName }}
                        </p>
                        <p style="font-size: 12px">
                          {{
                            $moment(comment.auditor.register.time).format(
                              "YYYY.MM.DD"
                            )
                          }}
                        </p>
                      </div>

                      <!-- <div
                          class="user_date"
                        >{{ $moment(comment.auditor.register.time).format("YYYY.MM.DD") }}</div> -->
                      <div class="more-btn-parent-div">
                        <button
                          type="button"
                          class="more_btn"
                          @click="toggleMore"
                          v-if="
                            !comment.owner ||
                            selectedChild.modify === true ||
                            selectedChild.remove === true
                          "
                        >
                          more
                        </button>

                        <div class="more_box box-absolute">
                          <!-- report comment -->
                          <a
                            class="cursor-pointer"
                            v-if="!comment.owner"
                            @click="reportComment(comment.id, comment.report)"
                            >{{ $t("1446") }}</a
                          >
                          <!-- modify comment -->
                          <a
                            class="cursor-pointer"
                            v-if="
                              selectedChild &&
                              selectedChild.modify === true &&
                              comment.owner
                            "
                            @click="editCommentSet(comment)"
                            >{{ $t("1448") }}</a
                          >
                          <!-- delete comment -->
                          <a
                            class="cursor-pointer"
                            v-if="
                              selectedChild &&
                              selectedChild.remove === true &&
                              comment.owner
                            "
                            @click="deleteComment(comment.id, 0)"
                            >{{ $t("1449") }}</a
                          >
                        </div>
                      </div>
                    </div>
                    <!-- //userbox -->

                    <div class="user_con" v-html="comment.contents"></div>

                    <div
                      class="user_imgList reply"
                      v-if="comment.images.length"
                      style="position: relative"
                    >
                      <a
                        href="javascript:void(null)"
                        v-for="(img, i) in comment.images"
                        :key="i"
                        @click="fileDisply(img)"
                        style="z-index: 99"
                      >
                        <img
                          @click="fileDisply(img.resourceUri, false)"
                          v-if="getType(img.contentType) === 'image'"
                          :src="img.resourceUri"
                          :alt="img.originalName"
                        />
                        <video-player
                          class="video-player-box"
                          v-if="getType(img.contentType) === 'video'"
                          ref="videoPlayer"
                          :options="getPayerOption(img)"
                          :playsinline="true"
                          customEventName="customstatechangedeventname"
                        />
                        <div
                          style="
                            position: absolute;
                            background-color: transparent;
                            width: 120px;
                            height: 100px;
                            margin-top: -100px;
                            z-index: 999;
                          "
                        ></div>
                      </a>
                    </div>

                    <div class="list_btn list_btn_cr">
                      <a
                        @click="likeComment(comment.id, comment.likes)"
                        class="like"
                        :class="{ on: comment.likes }"
                        >{{ $t("1443", { str: comment.likesCount }) }}</a
                      >
                      <a
                        v-if="selectedChild && selectedChild.register === true"
                        href="javascript:void(null)"
                        class="reply"
                        @click="toggleReply(comment.id)"
                        >{{ $t("1444") }}</a
                      >
                    </div>

                    <div class="d-none" :id="`commentInput_${comment.id}`">
                      <!-- {{ replyImg }} -->
                      <div
                        class="comment_box"
                        style="
                          bottom: 50px;
                          background: transparent;
                          border: 0;
                          display: flex;
                          white-space: nowrap;
                          overflow-x: auto;
                          position: inherit;
                        "
                        v-if="replyImg.length > 0"
                      >
                        <div
                          class="post-video position-relative mgr-16"
                          v-for="(img, i) in replyImg"
                          :key="i"
                          style="width: 90px"
                        >
                          <img
                            :src="img.resourceUri"
                            :alt="img.originalName"
                            style="width: 100px"
                            v-if="getType(img.contentType) == 'image'"
                          />
                          <video-player
                            v-if="getType(img.contentType) == 'video'"
                            class="video-player-box"
                            :options="{
                              muted: true,
                              language: 'en',
                              playbackRates: [0.7, 1.0, 1.5, 2.0],
                              sources: [
                                { type: img.contentType, src: img.resourceUri },
                              ],
                              height: 100,
                              width: 100,
                            }"
                            :playsinline="true"
                          />

                          <span
                            @click="replyImg.splice(i, 1)"
                            class="remove-img remove-image-new position-absolute t-color-white"
                            ><img src="/images/close.svg" style="width: 20px;}"
                          /></span>
                        </div>
                      </div>

                      <div class="comment_area reply_area">
                        <!--<button type="button" class="picture_btn">사진 업로드</button>-->
                        <button
                          type="button"
                          class="picture_btn"
                          @click="openFileUpload(false)"
                        ></button>
                        <button
                          type="button"
                          class="comment_btn"
                          @click="submitReply(comment.id, $event)"
                        >
                          댓글 업로드
                        </button>

                        <textarea
                          class="comment_textarea"
                          :placeholder="$t('1445')"
                          :id="'reply_text' + comment.id"
                        ></textarea>
                      </div>
                    </div>

                    <!-- rereply -->
                    <div
                      class="reply_box"
                      v-for="reply in comment.children"
                      :key="reply.id"
                    >
                      <!-- userbox -->
                      <div class="user_box">
                        <div class="user_img">
                          <img
                            v-if="reply.auditor.register.profile"
                            :src="reply.auditor.register.profile"
                            :alt="reply.auditor.register.name && reply.auditor.register.name.fullName"
                          />
                          <img
                            v-else
                            src="/images/avatar_image.png"
                            :alt="comment.auditor.register.name && comment.auditor.register.name.fullName"
                          />
                        </div>
                        <div class="user_txt">
                          <p class="name">
                            {{ reply.auditor.register.name ? reply.auditor.register.name.fullName : $t("S10082") }}
                          </p>
                          <p v-show="reply.auditor.register.storeName" class="date">
                            {{ reply.auditor.register.storeName }} |
                            {{ reply.auditor.register.responsibilityName }}
                          </p>
                          <p style="font-size: 12px">
                            {{
                              $moment(reply.auditor.register.time).format(
                                "YYYY.MM.DD"
                              )
                            }}
                          </p>
                        </div>

                        <!-- <div
                            class="user_date"
                          >{{ $moment(reply.auditor.register.time).format("YYYY.MM.DD") }}</div> -->
                        <!-- <button type="button" class="more_btn">more</button> -->
                        <div class="more-btn-parent-div">
                          <button
                            type="button"
                            class="more_btn"
                            @click="toggleMore"
                            v-if="
                              !reply.owner ||
                              selectedChild.modify === true ||
                              selectedChild.remove === true
                            "
                          >
                            more
                          </button>
                          <div class="more_box box-absolute">
                            <!-- report comment -->
                            <a
                              class="cursor-pointer"
                              v-if="!reply.owner"
                              @click="reportComment(reply.id, reply.report)"
                              >{{ $t("1446") }}</a
                            >
                            <!-- modify comment -->
                            <a
                              class="cursor-pointer"
                              v-if="
                                selectedChild &&
                                selectedChild.modify === true &&
                                reply.owner
                              "
                              @click="editReplySet(reply, comment.id)"
                              >{{ $t("1448") }}</a
                            >
                            <!-- delete comment -->
                            <a
                              class="cursor-pointer"
                              v-if="
                                selectedChild &&
                                selectedChild.remove === true &&
                                reply.owner
                              "
                              @click="deleteComment(reply.id, comment.id)"
                              >{{ $t("1449") }}</a
                            >
                          </div>
                        </div>
                      </div>
                      <!-- //userbox -->

                      <div class="user_con" v-html="reply.contents">
                        <!-- <span class="em">홍길동</span> -->
                      </div>

                      <div class="user_imgList reply">
                        <a
                          href="javascript:void(null)"
                          v-for="(img, i) in reply.images"
                          :key="i"
                        >
                          <img
                            v-if="getType(img.contentType) === 'image'"
                            :src="img.resourceUri"
                            :alt="img.originalName"
                          />
                          <video-player
                            class="video-player-box"
                            v-if="getType(img.contentType) === 'video'"
                            :options="getPayerOption(img)"
                            :playsinline="true"
                          />
                        </a>
                      </div>

                      <div class="list_btn list_btn_cr">
                        <a
                          href="javascript:void(null)"
                          @click="likeReply(reply.id, reply.likes, comment.id)"
                          class="like"
                          :class="{ on: reply.likes }"
                          >{{ $t("1443", { str: reply.likesCount }) }}</a
                        >
                      </div>
                    </div>
                    <!-- //rereply -->
                  </div>
                </div>
                <!-- //reply -->
              </div>
            </div>
            <div style="text-align: center; padding-top: 10px">
              <button
                type="button"
                v-if="comments.length > 0 && currentPage <= totalPages"
                class="btn btn-secondary"
                @click="getComments"
                style="margin: 10px"
              >
                {{ $t("3093") }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- //content -->
    </div>
    <!-- <infinite-loading @infinite="getComments" :identifier="infiniteId"  spinner="spiral"  ref="infiniteLoading" >
        <div slot="no-more" class="mgt-16">No more data</div>
        <div slot="no-results" class="mgt-16"></div>
    </infinite-loading> -->
  </div>
</template>

<script>
import ePromoterApi from "@/api/ePromoterApi.js";
import InfiniteLoading from "vue-infinite-loading";

// require styles
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    InfiniteLoading,
    videoPlayer,
  },
  beforeCreate() {
    //this.getComments();
    this.windowv = window;
  },
  mounted() {
    // this.getComments();
  },
  beforeMount() {
    this.boardId = this.$route.query.bId;
    ePromoterApi
      .boardAuth(this.boardId)
      .then((response) => {
        this.boardData = response.data.data;
        //console.log('pravin kumar sahhhhh',this.boardData);
        ePromoterApi
          .fetchMember()
          .then((response) => {
            this.mamberData = response.data.data;
            let myId = this.mamberData.responsibilityId;

            let permissionData = this.boardData.authPermission.find(
              (child) => child.partId == myId
            );
            if (permissionData) {
              this.selectedChild = permissionData;
            }
          })
          .catch((err) => {
            $state.error();
          });
      })
      .catch((err) => {
        $state.error();
      });
    this.setDetail();
    this.getComments();

    //alert(this.wheight)
  },
  data() {
    return {
      coomentActiveButton: false,
      commentValid: false,
      detail: null,
      comments: [],
      form: {
        contents: null,
        images: [],
      },
      replyImg: [],
      isComment: true,
      isNoData: false,
      currentPage: 1,
      totalPages: 1,
      infiniteId: +new Date(),
      isError: false,
      selectedChild: [],
      mamberData: [],
      windowv: {},
      boardId: null,
      commentEdit: false,
      commentEditId: null,
      replyEdit: false,
      replyEditId: null,
      boardData: null,
      bottom: false,
      isButtonDisabled: false,
    };
  },
  watch: {
    $route(to, from) {
      this.initData();
    },
  },

  beforeRouteLeave(to, from, next) {
    if (to.path == "/") {
      this.$router.push("/ePromoter?bId=" + this.boardId);
    } else {
      return next();
    }
  },

  methods: {
    bottomVisible() {
      const scrollY = window.scrollY;
      const visible = document.documentElement.clientHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const bottomOfPage = visible + scrollY > pageHeight;
      return bottomOfPage || pageHeight < visible;
    },
    ...mapActions("social", ["SET_LIKE", "SET_VIEW"]),
    getWHieght() {
      return $(window).width();
    },
    resizeIt(str) {
      var elmnt = document.getElementById("comment_textarea");
      elmnt.style.height = 0;
      var scHeight = elmnt.scrollHeight;
      elmnt.style.height = scHeight + "px";
    },
    setActive() {
      this.coomentActiveButton = true;
    },
    initData() {
      this.comments = [];
      this.currentPage = 1;
      this.totalPages = 1;
      this.infiniteId += 1;
    },
    resetVideo() {
      this.form.images = Array();
    },
    getPayerOption(img) {
      return {
        muted: true,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: img.contentType,
            src: img.resourceUri,
          },
        ],
        height: 100,
        width: 120,
      };
    },
    getType(contentType) {
      return contentType.split("/")[0];
    },
    editReplySet(reply, cid) {
      this.replyImg = reply.images;
      this.replyEditId = reply.id;
      this.replyEdit = true;
      //console.log();
      $("#reply_text" + cid).val(reply.contents);
      // evt.target
      //   .closest(".reply_area")
      //   .querySelector(".comment_textarea")
      //   .value = reply.contents;
      this.toggleReply(cid);
    },
    submitReply(originId, evt) {
      // search for reply comment
      let contents = evt.target
        .closest(".reply_area")
        .querySelector(".comment_textarea")
        .value.trim();
      if (!contents) return;

      this.$showLoading();

      if (!this.replyEdit) {
        ePromoterApi
          .boardAuth(this.boardId)
          .then((response) => {
            this.boardData = response.data.data;
            if (this.boardData.userCommToDayAuth) {
              // call API to add reply
              ePromoterApi
                .postReply(this.boardId, this.detail.id, originId, {
                  contents: contents,
                  images: this.replyImg,
                })
                .then((response) => {
                  this.$hideLoading();
                  evt.target
                    .closest(".reply_area")
                    .querySelector(".comment_textarea").value = null;
                  this.toggleReply(originId);
                  this.replyImg = [];
                  // add reply into parent
                  for (let c in this.comments) {
                    if (this.comments[c].id == originId) {
                      this.comments[c].children.push(response.data.data);
                    }
                  }
                })
                .catch((err) => {
                  this.$error({ content: err.errMsg }).then(() => {});
                });
            } else {
              this.$alert({
                //title: this.$t('779'), //가입 승인 대기 상태입니다.
                content: this.$t("3064"),
                accept: this.$t("3065"),
              })
                .then(() => {})
                .catch(() => {});
            }
          })
          .catch((err) => {
            $state.error();
          });
      } else {
        ePromoterApi
          .editReply(this.boardId, this.detail.id, this.replyEditId, {
            contents: contents,
            images: this.replyImg,
          })
          .then((response) => {
            this.$hideLoading();
            evt.target
              .closest(".reply_area")
              .querySelector(".comment_textarea").value = null;
            this.toggleReply(originId);
            this.replyImg = [];
            this.replyEdit = false;
            // add reply into parent
            for (let c in this.comments) {
              if (this.comments[c].id == originId) {
                let replyIndex = this.comments[c].children.findIndex(
                  (arr) => arr.id == this.replyEditId
                );
                this.comments[c].children[replyIndex] = response.data.data;
                this.replyEditId = null;
              }
            }
          })
          .catch((err) => {
            this.$error({ content: err.errMsg }).then(() => {});
          });
      }
    },
    uploadFile(evt) {
      if (!evt.target.files[0]) return;
      if (!this.invalidCountImg()) return;
      this.$showLoading();
      ePromoterApi
        .upload(evt.target.files[0])
        .then((response) => {
          // check if Image need to add into reply or comment
          if (this.isComment) this.form.images.push(response.data.data[0]);
          else this.replyImg.push(response.data.data[0]);

          this.$hideLoading();
        })
        .catch((err) => {
          this.$hideLoading();
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },
    invalidCountImg() {
      if (this.isComment && this.form.images.length >= 5) {
        this.$alert({
          // title: this.$t('72'),
          content: this.$t("1469"),
          accept: this.$t("1470"),
        });
        return false;
      } else {
        if (this.replyImg.length >= 5) {
          this.$alert({
            // title: this.$t('72'),
            content: this.$t("1469"),
            accept: this.$t("1470"),
          });
          return false;
        }
      }
      return true;
    },
    openFileUpload(status) {
      this.isComment = status;
      document.getElementById("commentFileUpload").click();
    },
    toggleMore(evt) {
      let field = evt.target
        .closest(".more-btn-parent-div")
        .querySelector(".more_box");
      if (field.style.display === "none") {
        field.style.display = "block";
      } else {
        field.style.display = "none";
      }
    },
    editCommentSet(comment) {
      this.form.contents = comment.contents;
      this.form.images = comment.images;
      this.commentEditId = comment.id;
      this.commentEdit = true;
    },
    setDetail() {
      this.$showLoading();
      ePromoterApi
        .socialDetails(this.$route.params.postId, this.boardId)
        .then((response) => {
          this.detail = response.data.data;
          this.SET_VIEW({
            id: this.detail.id,
            viewCount: this.detail.viewCount,
            commentCount: this.detail.commentCount,
          });
          if (this.detail) {
            let myId = this.mamberData.responsibilityId;
            this.detail.boardDto.authPermission.forEach((permission) => {
              let permissionData = permission.child.find(
                (child) => child.partId == myId
              );
              if (permissionData) {
                this.selectedChild = permissionData;
              }
            });
          }
          this.$hideLoading();
        })
        .catch((err) => {
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },
    patchLikeState(id, status) {
      this.$showLoading();

      let action = status
        ? ePromoterApi.patchPostLike(this.boardId, id)
        : ePromoterApi.patchPostDislike(this.boardId, id);

      action
        .then((response) => {
          this.detail.like = !status;
          this.detail.likesCount = !status
            ? this.detail.likesCount + 1
            : this.detail.likesCount - 1;
          this.SET_LIKE({
            id: id,
            likesCount: this.detail.likesCount,
            like: !status,
          });
          this.$hideLoading();
          let goBackPortfolio = this.$route.query.portfolio;
          if (goBackPortfolio == "likedsocial") {
            this.$router.push("/social-lesson");
          }
        })
        .catch((err) => {
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },
    deletePost() {
      this.$showLoading();

      ePromoterApi
        .deletePost(this.boardId, this.detail.id)
        .then((response) => {
          this.$hideLoading();
          //this.$router.push({ name: "SocialLearningListing" });
          this.$router.push("/ePromoter");
        })
        .catch((err) => {
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },
    askForDelete() {
      this.$confirm({
        // title: this.$t('72'),   // 학습을 중단한 강의입니다.
        content: this.$t("1877"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
        accept: this.$t("1879"), // 확인
        cancel: this.$t("1878"), //'TODO-취소'
      })
        .then(() => {
          this.deletePost();
        })
        .catch(() => {});
    },
    askForReport(status) {
      if (status) return;

      this.$confirm({
        // title: this.$t('72'),   // 학습을 중단한 강의입니다.
        content: this.$t("1450"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
        accept: this.$t("1451"), // 확인
        cancel: this.$t("1447"), //'TODO-취소'
      })
        .then(() => {
          this.reportPost();
        })
        .catch(() => {});
    },
    reportPost() {
      this.$showLoading();

      ePromoterApi
        .reportPost(this.boardId, this.detail.id)
        .then((response) => {
          this.$hideLoading();
          this.detail.report = true;
        })
        .catch((err) => {
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },
    setParams() {
      let params = {
        //sort: "id,desc",
        //contents: encodeURI(this.contents),
        page: this.currentPage,
        size: 10,
      };
      return params;
    },
    //     getComments($state) {
    //       let responseData = null;

    //       let params = this.setParams();
    //       if (this.totalPages >= this.currentPage) {
    //         //this.$showLoading();
    //         ePromoterApi
    //           .listComments(this.$route.params.postId, params)
    //           .then((response) => {
    //             responseData = response.data.data;
    //             _.map(responseData.content, (o) => {
    //               o.progressViewStatus = false;
    //             });

    //             this.comments = this.comments.concat(responseData.content);
    //             this.currentPage++;
    //             this.totalPages = responseData.totalPages;
    // console.log('state ----------@@',this.currentPage,this.totalPages);

    //             if (responseData.content.length) {
    //               $state.loaded();
    //             } else {
    //               $state.complete();
    //             }

    //             if (this.comments.length) {
    //               this.isNoData = false;
    //             } else {
    //               this.isNoData = true;
    //             }

    //             //this.$hideLoading();
    //           })
    //           .catch((err) => {
    //             //this.$hideLoading();
    //             $state.error();
    //           });
    //       } else {
    //         $state.complete();
    //       }
    //     },
    getComments() {
      let responseData = null;

      let params = this.setParams();
      if (this.$route.params.postId) {
        this.$showLoading();
        ePromoterApi
          .listComments(this.$route.params.postId, params)
          .then((response) => {
            responseData = response.data.data;
            this.comments = this.comments.concat(responseData.content);
            this.currentPage++;
            this.totalPages = responseData.totalPages;

            if (this.bottomVisible()) {
              this.getComments();
            }
            this.$hideLoading();
          })
          .catch((err) => {
            this.$hideLoading();
            //$state.error();
          });
      }
    },
    resetCommentForm() {
      this.form = {
        contents: null,
        images: [],
      };
    },
    submitComment() {
      if (this.form.contents.length<20) {
        // show alert
        this.$alert({
          //title: this.$t("72"), // 학습을 중단한 강의입니다.
          content: this.$t("S10043"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
          accept: this.$t("1884"), // 확인
        });
        return;
      }
      
      this.isButtonDisabled = true;
      if (!this.detail) return;
      if (this.form.contents && this.form.contents.trim().length > 0) {
        this.commentValid = false;
        this.$showLoading();
        if (this.commentEdit) {
          ePromoterApi
            .commentEdit(
              this.detail.id,
              this.form,
              this.boardId,
              this.commentEditId
            )
            .then((resp) => {
              // reset comment form
              this.resetCommentForm();
              //this.comments.push(resp.data.data);
              let commentIndex = this.comments.findIndex(
                (el) => el.id == resp.data.data.id
              );
              this.comments[commentIndex] = resp.data.data;
              this.commentEdit = false;
              //this.detail.commentCount = this.detail.commentCount + 1;
              this.$hideLoading();
              this.isButtonDisabled = false;
            })
            .catch((err) => {
              this.$error({ content: err.errMsg }).then(() => {});
            });
        } else {
          ePromoterApi
            .boardAuth(this.boardId)
            .then((response) => {
              this.boardData = response.data.data;
              if (this.boardData.userCommToDayAuth) {
                ePromoterApi
                  .commentPost(this.detail.id, this.form, this.boardId)
                  .then((resp) => {
                    // reset comment form
                    this.resetCommentForm();

                    this.comments.push(resp.data.data);
                    this.detail.commentCount = this.detail.commentCount + 1;
                    this.SET_VIEW({
                      id: this.detail.id,
                      viewCount: this.detail.viewCount,
                      commentCount: this.detail.commentCount,
                    });
                    this.$hideLoading();
                    this.isButtonDisabled = false;
                  })
                  .catch((err) => {
                    this.$error({ content: err.errMsg }).then(() => {});
                  });
              } else {
                this.$alert({
                  //title: this.$t('779'), //가입 승인 대기 상태입니다.
                  content: this.$t("3064"),
                  accept: this.$t("3065"),
                })
                  .then(() => {
                    this.isButtonDisabled = false;
                  })
                  .catch(() => {});
              }
            })
            .catch((err) => {
              $state.error();
            });
        }
      } else {
        this.isButtonDisabled = false;
        this.commentValid = true;
      }
    },
    likeComment(id, status) {
      this.$showLoading();

      let action = status
        ? ePromoterApi.dislikeComment(this.boardId, this.detail.id, id)
        : ePromoterApi.likeComment(this.boardId, this.detail.id, id);

      action
        .then((response) => {
          this.$hideLoading();
          // search comment
          for (let c in this.comments) {
            if (this.comments[c].id == id) {
              this.comments[c].likes = !status;
              this.comments[c].likesCount = !status
                ? this.comments[c].likesCount + 1
                : this.comments[c].likesCount - 1;
              return;
            }
          }
        })
        .catch((err) => {
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },
    likeReply(replyId, replyStatus, id) {
      this.$showLoading();

      let action = replyStatus
        ? ePromoterApi.dislikeComment(this.boardId, this.detail.id, replyId)
        : ePromoterApi.likeComment(this.boardId, this.detail.id, replyId);

      action
        .then((response) => {
          this.$hideLoading();
          // search comment
          for (let c in this.comments) {
            if (this.comments[c].id == id) {
              // search for the reply in selected comment
              for (let r in this.comments[c].children) {
                if (this.comments[c].children[r].id == replyId) {
                  this.comments[c].children[r].likes = !replyStatus;
                  this.comments[c].children[r].likesCount = !replyStatus
                    ? this.comments[c].children[r].likesCount + 1
                    : this.comments[c].children[r].likesCount - 1;
                }
              }
              return;
            }
          }
        })
        .catch((err) => {
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },
    deleteComment(id, pid) {
      this.$showLoading();

      ePromoterApi
        .deleteComment(this.boardId, this.detail.id, id)
        .then((response) => {
          this.$hideLoading();
          this.detail.commentCount = this.detail.commentCount - 1;
          this.SET_VIEW({
            id: this.detail.id,
            viewCount: this.detail.viewCount,
            commentCount: this.detail.commentCount,
          });
          // search comment
          if (pid > 0) {
            for (let c in this.comments) {
              if (this.comments[c].id == pid) {
                for (let r in this.comments[c].children) {
                  if (this.comments[c].children[r].id == id) {
                    this.comments[c].children.splice(r, 1);
                    return;
                  }
                }
                return;
              }
            }
          } else {
            for (let c in this.comments) {
              if (this.comments[c].id == id) {
                this.comments.splice(c, 1);
                return;
              }
            }
          }
        })
        .catch((err) => {
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },
    reportComment(id, status) {
      if (status) return;

      this.$showLoading();

      ePromoterApi
        .reportComment(this.boardId, this.detail.id, id)
        .then((response) => {
          this.$hideLoading();
          if (this.comments[c].id == id) {
            this.comments[c].report = true;
            return;
          }
        })
        .catch((err) => {
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },
    toggleReply(commentId) {
      //this.replyImg = [];
      document
        .getElementById(`commentInput_${commentId}`)
        .classList.toggle("d-none");
    },
    fileDisply(data) {
      localStorage.setItem("ePromoterlFile", JSON.stringify(data));
      this.$router.push(
        "/e-Promoter/file-display?postId=" +
          this.$route.params.postId +
          "&bId=" +
          this.$route.query.bId
      );
    },
    goBacKPreviousPage() {
      let goBackPortfolio = this.$route.query.portfolio;
      if (goBackPortfolio == "likedsocial") {
        this.$router.push("/social-lesson");
      } else if (goBackPortfolio == "epromoter-mypost") {
        this.$router.push(
          "/ePromoter-mypost/?bId=sns&mypost=" + this.$route.params.postId
        );
      } else {
        this.$router.push(
          "/ePromoter?bId=" + this.boardId + "&a=" + this.$route.query.a
        );
      }
    },
  },
};
</script>

<style scoped>
.remove-image-new {
  top: -16px;
  right: -16px;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  background: #ddd;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 3px solid #fff;
  color: #fff;
  line-height: 0px;
}
.reply_area {
  border: solid 1px #c8c8c8;
}
.d-none {
  display: none;
}
.box-absolute {
  position: absolute;
  z-index: 1;
  right: 0;
  top: 20px;
}

/* reset */

.sm_star * {
  margin: 0;
  padding: 0;
  font-family: "Roboto", Arial, dotum, sans-serif;
  font-weight: normal;
  font-size: 13px;
  color: #818181;
}

ol,
ul,
li {
  list-style: none;
}

table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
}

th {
  font-weight: normal;
}

form,
fieldset,
iframe {
  display: block;
  border: 0;
}

img,
button {
  border: none;
  vertical-align: middle;
}

hr {
  height: 0;
  display: none;
}

i,
em,
address {
  font-style: normal;
}

label,
button {
  cursor: pointer;
}

blockquote,
q {
  quotes: none;
}

caption,
.hide {
  visibility: hidden;
  width: 0;
  height: 0;
  padding: 0;
  margin: 0;
  font-size: 0;
  text-indent: -9999em;
}

legend {
  overflow: hidden;
  visibility: hidden;
  position: absolute;
  width: 0;
  height: 0;
  padding: 0;
  margin: 0;
  font-size: 0;
  text-indent: -100%;
  white-space: nowrap;
  z-index: -1;
}

input[type="text"],
input[type="password"],
input[type="email"],
input[type="search"],
input[type="image"],
input[type="tel"],
textarea {
  -webkit-appearance: none;
  -webkit-border-radius: 0;
}

input:focus {
  outline: none;
}

::-webkit-input-placeholder {
  color: #999;
}

::-moz-selection {
  background: #005aab;
  color: #fff;
  text-shadow: none;
}

::-webkit-selection {
  background: #005aab;
  color: #fff;
  text-shadow: none;
}

a {
  color: #222;
  text-decoration: none;
}

a:link,
a:visited {
  text-decoration: none;
}

button {
  display: inline-block;
  background: none;
  border: none;
  outline: none;
}

::selection {
  background: #005aab;
  color: #fff;
  text-shadow: none;
}

/* header */

.sm_star {
  position: relative;
  margin: 0 auto;
}

.sm_star.backBg:after {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 997;
}

.sm_header {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 55px;
  border-bottom: 1px solid #e9e9e9;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
}

.sm_header h1 {
  text-align: center;
  color: #212121;
  font-size: 1.25rem;
  font-weight: 500;
  height: 55px;
  line-height: 55px;
}

.sm_header .menu_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
}

.sm_header .menu_btn span {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  font-size: 0;
  display: inline-block;
}

.sm_header .menu_btn:after {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin-top: -5px;
}

.sm_header .menu_btn:before {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin-top: 5px;
}

.sm_header .search_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url("/images/search_btn.svg") center center no-repeat;
  background-size: 22px auto;
}

.sm_header .search_btn span {
  font-size: 0;
  text-indent: -9999px;
}

.sm_header .back_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url("/images/back_btn.png") center center no-repeat;
  background-size: 22px auto;
  font-size: 0;
  text-indent: -9999px;
}

.sm_header .more_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url("/images/more_btn.png") center center no-repeat;
  background-size: 22px auto;
  font-size: 0;
  text-indent: -9999px;
}

.sm_header .more_box {
  position: absolute;
  right: 15px;
  top: 45px;
  width: 100px;
  z-index: 10;
}

.sm_header .close_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url("/images/close_btn.svg") center center no-repeat;
  background-size: 22px auto;
  font-size: 0;
  text-indent: -9999px;
}

.more_box {
  display: inline-block;
  padding: 15px 20px;
  background: #fff;
  box-shadow: 0 10px 13px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px rgba(206, 218, 220, 0.5);
  border-radius: 4px;
  display: none;
}

.more_box a {
  display: block;
  color: #333;
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  text-align: left;
  margin-bottom: 5px;
}

.more_box a:nth-last-child(1) {
  margin-bottom: 0;
}

.sm_header .upload_btn {
  width: 55px;
  height: 55px;
  line-height: 55px;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  font-size: 15px;
  color: #2d6dcc;
}

.sm_header .upload_btn span {
  font-size: 15px;
  color: #2d6dcc;
  font-weight: 500;
}

.search_box {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 10;
  display: none;
}

.search_box .search_close {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url("/images/close_btn.svg") center center no-repeat;
  background-size: 22px auto;
  text-indent: -9999px;
}

.search_box .search_form {
  position: absolute;
  left: 60px;
  top: 12px;
  border: 0;
  background: #fff;
  font-size: 18px;
  color: #212121;
  height: 30px;
  width: calc(100% - 125px);
}

/* layer img */

.layer_img {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 999;
  overflow-x: hidden;
  overflow-y: auto;
  display: none;
}

.layer_img .layer_close {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  z-index: 999;
}

.layer_img .layer_close:before {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  display: inline-block;
  content: "";
  position: absolute;
  transform: rotate(-45deg);
  margin-top: -2px;
  top: 50%;
  left: 50%;
  margin-left: -9px;
}

.layer_img .layer_close:after {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  display: inline-block;
  content: "";
  position: absolute;
  transform: rotate(45deg);
  margin-top: -2px;
  top: 50%;
  left: 50%;
  margin-left: -9px;
}

.layer_img .img_placer {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  white-space: nowrap;
  width: 100%;
}

.layer_img .img {
  display: inline-block;
  width: 100%;
  vertical-align: middle;
  text-align: center;
  white-space: normal;
  position: relative;
}

.layer_img .img_placer:after {
  display: inline-block;
  width: 100%;
  height: 100%;
  vertical-align: middle;
  content: "";
}

.layer_img .img img {
  display: inline;
  max-width: 100%;
}

/* layer pop */

.layer_pop {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 999;
  display: none;
}

.layer_con {
  width: 90%;
  max-width: 300px;
  background: #fff;
  box-sizing: border-box;
  padding: 25px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 4px;
  box-shadow: 0 19px 38px 0 rgba(0, 0, 0, 0.26);
}

.layer_con .layer_txt {
  font-size: 16px;
  color: #818181;
  line-height: 1.5;
}

.layer_con .layer_btn {
  position: relative;
  padding: 30px 0 0 0;
  text-align: right;
}

.layer_con .layer_btn a {
  display: inline-block;
  padding: 5px 15px;
  color: #2d6dcc;
  font-weight: 500;
  font-size: 14px;
  margin-left: 10px;
}

/* upload */

.upload_wrap {
  position: relative;
  padding: 15px;
}

.upload_list {
  position: relative;
  font-size: 0;
}

.upload_list > li {
  display: inline-block;
  vertical-align: top;
  width: 32%;
  margin-right: 2%;
  margin-bottom: 2%;
}

.upload_list > li:nth-child(3n) {
  margin-right: 0;
}

.upload_list .file {
  position: relative;
  height: 0;
  padding-top: 100%;
}

.upload_list .file > a {
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.upload_list .file img,
.upload_list .file video,
.upload_list .file iframe {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.upload_list .file.active a:after {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(49, 61, 75, 0.3);
}

.upload_list .file .pic {
  display: inline-block;
  width: 25px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  color: #fff;
  background: #2d6dcc;
  font-size: 13px;
  position: absolute;
  right: 10px;
  top: 10px;
  border-radius: 50%;
  z-index: 10;
}

/* user */

.user_box {
  position: relative;
}

.user_box .user_img {
  position: relative;
  display: inline-block;
  border-radius: 50%;
  overflow: hidden;
  width: 40px;
  height: 40px;
  vertical-align: middle;
  margin-right: 15px;
}

.user_box .user_img img {
  /* width: auto; */
  /* height: auto; */
  min-width: 100%;
  min-height: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.user_box .user_txt {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}

.user_box .user_txt .name {
  font-size: 14px;
  color: #212121;
}

.user_box .user_txt .date {
  position: relative;
  padding: 2px 0 0 0;
  color: #818181;
  font-size: 14px;
}

.user_box .user_write {
  position: absolute;
  right: 0;
  top: 0;
}

.user_box .user_write > a {
  display: inline-block;
  vertical-align: top;
  margin-left: 15px;
  background-size: 24px auto !important;
}

.user_box .user_write .write_btn {
  font-size: 12px;
  color: #acb4be;
  padding-top: 28px;
  background: url("/images/write_icon.png") center top no-repeat;
}

.user_box .user_write .write_btn.me {
  background: url("/images/my_write_icon.png") center top no-repeat;
}

.user_box .user_date {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 12px;
  color: #818181;
}

.user_fixed {
  position: fixed;
  left: 0;
  top: 55px;
  width: 100%;
  height: 75px;
  background: #fff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  padding: 15px;
  z-index: 10;
}

/* style */

.sm_wrap {
  position: relative;
  padding: 55px 0 0 0;
}

.sm_list {
  position: relative;
}

.sm_list.view {
  padding-bottom: 85px;
}

.sm_list.learning {
  padding: 90px 15px 15px 15px;
  background: #f9f9f9;
  position: relative;
}

.sm_list_box {
  position: relative;
}

.sm_list_box > .list_box {
  position: relative;
  margin-bottom: 15px;
}

.sm_list_box > .list_box:nth-last-child(1) {
  margin-bottom: 0;
}

.sm_list .no_data {
  position: relative;
  height: calc(100vh - 210px);
  text-align: center;
  padding: 50px 0 0 0;
  min-height: 300px;
}

.sm_list .no_data .no_img img {
  max-width: 120px;
}

.sm_list .no_data p:nth-child(2) {
  position: relative;
  padding: 20px 0 0 0;
  font-size: 16px;
  font-weight: 500;
  color: #212121;
}

.sm_list .no_data p:nth-child(3) {
  position: relative;
  padding: 15px 0 0 0;
  font-size: 14px;
  font-weight: 500;
  color: #818181;
  line-height: 1.57;
}

.sm_list.view .list_box {
  margin-bottom: 0;
}

.list_box {
  position: relative;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  padding: 15px;
}

.list_box .user_con {
  padding: 15px 0 0 0;
}

.list_box .user_tag {
  padding: 10px 0 0 0;
}

.list_box .user_opt {
  margin: 20px 0 0 0;
}

.list_box .user_imgList {
  margin: 20px 0 0 0;
  margin-right: -15px !important;
  margin-left: -15px !important;
}

.user_con {
  position: relative;
  font-size: 14px;
  color: #818181;
  line-height: 1.57;
}

.user_con .em {
  color: #212121;
  margin-right: 5px;
  font-size: 14px;
}

.user_tag {
  position: relative;
  font-size: 0;
}

.user_tag span {
  display: inline-block;
  vertical-align: top;
  margin-right: 5px;
  font-size: 12px;
  color: #313d4b;
  padding: 2px 3px;
  background: #f4f5f6;
  border-radius: 2px;
}

.user_opt {
  position: relative;
  font-size: 12px;
  color: #818181;
}

.user_opt .right {
  position: absolute;
  right: 0;
  top: 0;
  color: #818181;
}

.list_btn {
  position: relative;
  text-align: center;
  font-size: 0;
  border-top: 1px solid #e6eced;
  margin: 15px 0 0 0;
  padding: 10px 0 0 0;
  display: flex;
  justify-content: space-evenly;
}

.list_btn_cr {
  justify-content: flex-start !important;
}

.list_btn a {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  padding: 0 10px 0 25px;
  background-size: 17px auto;
  background-position: left center;
  background-repeat: no-repeat;
  margin: 0 5px;
  color: #acb4be;
}
.list_btn a.like {
  color: #818181 !important;
  background-image: url("/images/like_btn.png");
}

.list_btn a.like.on {
  color: #448aff !important;
  background-image: url("/images/like_btn_on.png");
}

.list_btn a.reply {
  background-image: url("/images/reply_btn.png");
}

.list_btn a.share {
  background-image: url("/images/share_btn.png");
}

.user_imgList {
  position: relative;
  font-size: 0;
}

.user_imgList a {
  display: inline-block;
  position: relative;
}

.user_imgList a img,
.user_imgList a video {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: translate(-50%, -50%);
}

.user_imgList a.more:before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.4;
  z-index: 1;
}

.user_imgList a.more span {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 18px;
  z-index: 2;
}

.user_imgList > a:nth-child(1) {
  width: 66%;
  height: 0;
  padding-top: 66%;
}

.user_imgList > a:nth-child(2) {
  width: 32%;
  height: 0;
  padding-top: 32%;
  position: absolute;
  right: 0;
  top: 0;
}

.user_imgList > a:nth-child(3) {
  width: 32%;
  height: 0;
  padding-top: 32%;
  position: absolute;
  right: 0;
  bottom: 0;
}

.user_imgList.view a {
  display: block;
  padding-top: 0;
  height: auto;
  position: relative;
  right: auto;
  top: auto;
  width: auto;
  margin-bottom: 10px;
}

.user_imgList.view a img {
  position: relative;
  left: 0;
  top: auto;
  width: auto;
  max-width: 100%;
  height: auto;
  transform: none;
}

.user_imgList.reply {
  margin: 0 0 0 55px;
  white-space: nowrap;
  overflow-x: auto;
  padding-left: 74px;
}

.user_imgList.reply a {
  display: inline-block;
  width: 100px;
  height: 100px;
  padding-top: 0;
  position: relative;
  left: auto;
  top: auto;
  margin-right: 10px;
}

.input_file .user_imgList {
  white-space: nowrap;
  overflow-x: auto;
}

.input_file .user_imgList a {
  display: inline-block;
  width: 100px;
  height: 100px;
  padding-top: 0;
  position: relative;
  left: auto;
  top: auto;
  margin-right: 10px;
}

.user_imgList a.video:after {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  background: rgba(49, 61, 75, 0.3);
  position: absolute;
  left: 0;
  top: 0;
}

.user_imgList a.video:before {
  content: "";
  display: inline-block;
  width: 25px;
  height: 25px;
  background: url("/images/play_icon.png") center center no-repeat;
  background-size: 25px auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.reply_wrap {
  position: relative;
  background: #f9f9f9;
  padding: 15px;
}

.reply_wrap > div:nth-last-child(1) {
  margin-bottom: 0;
}

.reply_box {
  position: relative;
  margin-bottom: 15px;
}

.reply_box .user_box .user_date {
  right: 40px;
  color: #a6a6a6;
}

.reply_box .user_box .more_btn {
  width: 22px;
  height: 22px;
  background: url("/images/reply_more_btn.png") center center no-repeat;
  background-size: 22px auto;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0;
  text-indent: -9999px;
}

.reply_box .user_con {
  padding: 10px 15px 10px 58px;
}

.reply_box .list_btn {
  text-align: left;
  border-top: 0;
  margin: 0;
  padding: 0 0 0 55px;
}

.reply_box > .reply_box {
  padding: 10px 0 0 50px;
}

.comment_box {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 9999;
  padding: 15px 15px 20px 15px;
  background: #fff;
  box-sizing: border-box;
  border-top: 1px solid #e6eced;
}

.comment_area {
  position: relative;
}

.comment_area button {
  display: inline-block;
  width: 50px;
  height: 50px;
  text-indent: -9999px;
  font-size: 0;
  position: absolute;
  top: 0;
  vertical-align: top;
}

.comment_area .picture_btn {
  background: url("/images/picture_btn.png") center center no-repeat;
  background-size: 22px auto;
  position: relative;
}

.comment_area .video_btn {
  background: url("/images/video_btn.png") center center no-repeat;
  background-size: 22px auto;
  position: relative;
}

.comment_area .comment_btn {
  background: url("/images/comment_btn.png") center center no-repeat;
  background-size: 22px auto;
  right: 0;
}

.comment_area .comment_btn.on {
  background: url("/images/comment_btn_on.png") center center no-repeat;
  background-size: 22px auto;
}

.comment_textarea {
  position: relative;
  vertical-align: top;
  font-size: 14px;
  background: none;
  border: 0;
  width: calc(100% - 130px);
  resize: none;
  outline: none;
  height: 25px;
  margin-top: 14px;
}

.comment_area .tail_txt {
  position: absolute;
  right: 0;
  top: 15px;
  font-size: 14px;
  color: #acb4be;
}

.search_list {
  position: relative;
  background: #f9f9f9;
  padding: 15px;
  min-height: calc(100vh - 85px);
}

.search_list .no_data {
  position: relative;
  text-align: center;
  padding: 30px 0 0 0;
  min-height: 300px;
}

.search_list .no_data p:nth-child(1) {
  position: relative;
  font-size: 16px;
  font-weight: 500;
  color: #212121;
}

.search_list .no_data p:nth-child(2) {
  position: relative;
  padding: 15px 0 0 0;
  font-size: 14px;
  font-weight: 500;
  color: #818181;
  line-height: 1.57;
}

.write_wrap {
  position: relative;
  padding-bottom: 85px;
}

.write_tag {
  position: relative;
  padding: 15px;
  background: #fff;
  border-bottom: 1px solid #e6eced;
}

.write_tag .tag_tail {
  position: relative;
  padding: 10px 15px 0 15px;
  font-size: 12px;
  color: #acb4be;
}

.write_tag .tag_form {
  position: relative;
  padding: 15px;
  border-radius: 4px;
  border: 1px solid rgba(172, 180, 190, 0.7);
  min-height: 20px;
}

.write_tag .tag_form .tag_btn {
  width: 25px;
  height: 25px;
  font-size: 0;
  text-indent: -9999px;
  background: url("/images/addTag_icon.png") center center no-repeat;
  background-size: 22px auto;
  vertical-align: middle;
  margin-right: 5px;
}

.write_tag .tag_form span.txt {
  font-size: 14px;
  color: #acb4be;
  vertical-align: middle;
  line-height: 1;
}

.write_tag .tag_form span.tag {
  display: inline-block;
  padding: 3px 5px;
  background: #f0f1f2;
  font-size: 14px;
  color: #313d4b;
  vertical-align: middle;
  margin-right: 3px;
  line-height: 1.4;
}

.write_tag .tag_form span.tag.txt {
  color: #313d4b;
  line-height: 1.4;
  background: none;
}

.write_form {
  position: relative;
  padding: 15px;
  background: #fff;
}

.write_form textarea {
  border: 0;
  background: none;
  font-size: 14px;
  color: #313d4b;
  line-height: 1.57;
  width: 100%;
  height: calc(100vh - 295px);
  box-sizing: border-box;
  min-height: 300px;
  resize: none;
  outline: none;
}

.tag_list {
  position: relative;
}

.tag_list ul {
  position: relative;
}

.tag_list ul li {
  position: relative;
  display: block;
  background: #f9f9f9;
  border-bottom: 1px solid #e6eced;
}

.tag_list ul li span {
  display: block;
  padding: 15px;
}

.input_file {
  position: fixed;
  left: 0;
  bottom: 85px;
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  z-index: 10;
  background: #fff;
}

.input_file + .write_form textarea {
  min-height: inherit;
  height: calc(100vh - 410px);
}

.edit_wrap {
  position: relative;
  height: calc(100vh - 55px);
  text-align: center;
  overflow-x: hidden;
  overflow-y: auto;
}

.edit_wrap .placer {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  white-space: nowrap;
  width: 100%;
}

.edit_wrap .placer:after {
  display: inline-block;
  width: 100%;
  height: 100%;
  vertical-align: middle;
  content: "";
}

.edit_wrap .edit_file {
  display: inline-block;
  width: 100%;
  vertical-align: middle;
  text-align: center;
  white-space: normal;
  position: relative;
}

.edit_wrap .edit_file img {
  display: inline;
  max-width: 100%;
}

.edit_wrap .edit_file .video {
  display: inline-block;
  position: relative;
}

.edit_wrap .edit_file .video:after {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  background: rgba(49, 61, 75, 0.3);
  position: absolute;
  left: 0;
  top: 0;
}

.edit_wrap .edit_file .video:before {
  content: "";
  display: inline-block;
  width: 50px;
  height: 50px;
  background: url("/images/play_icon.png") center center no-repeat;
  background-size: 50px auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.cursor-pointer {
  cursor: pointer;
}

.commentInvaliderror::-webkit-input-placeholder {
  color: #fc5356;
}

.commentInvaliderror:-moz-placeholder {
  /* Firefox 18- */
  color: #fc5356;
}

.commentInvaliderror::-moz-placeholder {
  /* Firefox 19+ */
  color: #fc5356;
}

.commentInvaliderror:-ms-input-placeholder {
  color: #fc5356;
}

.commentInvaliderror::placeholder {
  color: #fc5356;
}
</style>
